import React, { createContext, useCallback, useContext, useState, useEffect } from "react";
import { fetchMe, loginWithPassword, logoutSession, registerWithPassword } from "../api/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

const DEV_MODE = process.env.REACT_APP_DEV_MODE === "true";

const isDemoMode = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem("demoMode") === "1";
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const data = await fetchMe();
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const login = async (email, password) => {
    if (DEV_MODE || isDemoMode()) {
      await fetchUser();
      return;
    }
    const data = await loginWithPassword({ email, password });
    setUser(data);
  };

  const register = async (email, password) => {
    if (DEV_MODE || isDemoMode()) {
      await fetchUser();
      return;
    }
    const data = await registerWithPassword({ email, password });
    setUser(data);
  };

  const loginWithGitHub = () => {
    return null;
  };

  const logout = async () => {
    const demo = isDemoMode();
    if (!DEV_MODE && !demo) {
      await logoutSession();
    }
    if (demo) {
      window.localStorage.removeItem("demoMode");
    }
    setUser(null);
    if (demo) {
      window.location.href = "/";
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        register,
        loginWithGitHub,
        logout,
        fetchUser,
        refreshUser: fetchUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
